<div class="website-content" style="max-width:72rem;padding:0 var(--wa-spacing-x-large) var(--wa-spacing-x-large) var(--wa-spacing-x-large);">
	<div class="wa-stack wa-gap-xl">
		<wa-button [routerLink]="['/plugins']" appearance="plain" variant="neutral">Back to Plugins</wa-button>
		<wa-card appearance="outlined">
			<div class="wa-stack wa-gap-m">
				<div class="wa-stack wa-gap-s">
					<h1 waHeading="xl" waText>JWebMP Core</h1>
					<p waBody="m" waText>Strongly-typed HTML/CSS/JS component model &mdash; the entire HTML5 element set as Java classes with CRTP fluent APIs, 50+ server-driven event adapters, typed CSS builder, dual-mode rendering &#40;HTML and JSON&#41;, and SPI-driven extensibility. Every component serves dual purposes: toString&#40;true&#41; renders as full HTML with all CSS/JS, toString&#40;&#41; renders as JSON for AJAX/API payloads.</p>
					<div class="wa-cluster wa-gap-xs">
						<wa-tag pill variant="neutral">Java 25+</wa-tag>
						<wa-tag pill variant="neutral">Guice 7</wa-tag>
						<wa-tag pill variant="neutral">Vert.x 5</wa-tag>
						<wa-tag pill variant="neutral">Maven 4</wa-tag>
						<wa-tag pill variant="neutral">JPMS Modular</wa-tag>
					</div>
				</div>
				<wa-divider></wa-divider>
				<div class="wa-stack wa-gap-xs">
					<div waCaption="s" waFontWeight="semibold" waText>COORDINATES &amp; MODULE</div>
					<p waBody="s" waText>Maven: com.jwebmp.core:core</p>
					<p waBody="s" waText>JPMS Module: com.jwebmp.core</p>
					<p waBody="s" waText>Built on: JWebMP 2.0.0</p>
				</div>
				<div class="wa-stack wa-gap-xs">
					<div waCaption="s" waFontWeight="semibold" waText>INSTALLATION</div>
					<div class="code-block-wrapper">
						<div class="code-block-label" waCaption="s" waFontWeight="semibold" waText>Maven</div>
						<markdown [data]="mdContent_83" class="aside-snippet-code wa-body-s" clipboard lineNumbers></markdown>
					</div>
					<div class="code-block-wrapper">
						<div class="code-block-label" waCaption="s" waFontWeight="semibold" waText>Gradle &#40;Kotlin DSL&#41;</div>
						<markdown [data]="mdContent_84" class="aside-snippet-code wa-body-s" clipboard lineNumbers></markdown>
					</div>
				</div>
				<wa-divider></wa-divider>
				<div class="wa-stack wa-gap-s">
					<div waCaption="s" waFontWeight="semibold" waText>COMPONENTS</div>
					<div class="wa-grid wa-gap-s" style="--min-column-size:18rem;">
						<wa-card appearance="outlined">
							<div class="wa-stack wa-gap-xs">
								<h4 waHeading="s" waText>Page</h4>
								<p waBody="s" waColorText="quiet" waText>Top-level HTML page container with head, body, CSS/JS queues</p>
								<div waCaption="s" waColorText="quiet" waFontWeight="semibold" waText>com.jwebmp.core.base.html</div>
							</div>
						</wa-card>
						<wa-card appearance="outlined">
							<div class="wa-stack wa-gap-xs">
								<h4 waHeading="s" waText>DivSimple</h4>
								<p waBody="s" waColorText="quiet" waText>Simplified div for quick component authoring</p>
								<div waCaption="s" waColorText="quiet" waFontWeight="semibold" waText>com.jwebmp.core.base.html</div>
							</div>
						</wa-card>
						<wa-card appearance="outlined">
							<div class="wa-stack wa-gap-xs">
								<h4 waHeading="s" waText>Paragraph</h4>
								<p waBody="s" waColorText="quiet" waText>HTML paragraph element</p>
								<div waCaption="s" waColorText="quiet" waFontWeight="semibold" waText>com.jwebmp.core.base.html</div>
							</div>
						</wa-card>
						<wa-card appearance="outlined">
							<div class="wa-stack wa-gap-xs">
								<h4 waHeading="s" waText>Table</h4>
								<p waBody="s" waColorText="quiet" waText>HTML table with typed header, body, and footer sections</p>
								<div waCaption="s" waColorText="quiet" waFontWeight="semibold" waText>com.jwebmp.core.base.html</div>
							</div>
						</wa-card>
						<wa-card appearance="outlined">
							<div class="wa-stack wa-gap-xs">
								<h4 waHeading="s" waText>Form</h4>
								<p waBody="s" waColorText="quiet" waText>HTML form with typed input bindings</p>
								<div waCaption="s" waColorText="quiet" waFontWeight="semibold" waText>com.jwebmp.core.base.html</div>
							</div>
						</wa-card>
						<wa-card appearance="outlined">
							<div class="wa-stack wa-gap-xs">
								<h4 waHeading="s" waText>InputTextType</h4>
								<p waBody="s" waColorText="quiet" waText>Typed text input element</p>
								<div waCaption="s" waColorText="quiet" waFontWeight="semibold" waText>com.jwebmp.core.base.html.inputs</div>
							</div>
						</wa-card>
						<wa-card appearance="outlined">
							<div class="wa-stack wa-gap-xs">
								<h4 waHeading="s" waText>Feature</h4>
								<p waBody="s" waColorText="quiet" waText>Wraps JS libraries with typed options and CSS/JS references</p>
								<div waCaption="s" waColorText="quiet" waFontWeight="semibold" waText>com.jwebmp.core.base</div>
							</div>
						</wa-card>
					</div>
				</div>
				<div class="wa-stack wa-gap-xs">
					<div waCaption="s" waFontWeight="semibold" waText>FEATURES</div>
					<p waBody="s" waColorText="quiet" waText>Complete HTML5 element library &mdash; every element &#40;Div, Span, Table, Form, Input, Select, Canvas, Video, Article, Section, ...&#41; as typed Java class with CRTP fluent API</p>
					<p waBody="s" waColorText="quiet" waText>Dual rendering modes &mdash; toString&#40;true&#41; for full HTML with CSS/JS, toString&#40;&#41; for JSON serialization</p>
					<p waBody="s" waColorText="quiet" waText>Typed input elements &mdash; InputTextType, InputEmailType, InputNumberType, InputDateType, InputFileType, InputCheckBoxType, InputRadioType, and 15 more</p>
					<p waBody="s" waColorText="quiet" waText>Typed CSS builder &mdash; annotation-driven CSS via &#64;CSS across 14 sub-packages: backgrounds, borders, colours, fonts, margins, padding, displays, lists, tables, text, outline, measurement, height/width, image</p>
					<p waBody="s" waColorText="quiet" waText>50+ server-driven event adapters &mdash; OnClickAdapter, OnChangeAdapter, OnSubmitAdapter, OnDragAdapter, OnKeyDownAdapter, OnMouseEnterAdapter, and more</p>
					<p waBody="s" waColorText="quiet" waText>Page configurators &mdash; IPageConfigurator SPI for injecting CSS links, JS references, dynamic scripts before rendering</p>
					<p waBody="s" waColorText="quiet" waText>AJAX pipeline &mdash; AjaxCall/AjaxResponse carry event payloads and DOM update instructions between browser and server</p>
					<p waBody="s" waColorText="quiet" waText>Feature system &mdash; Feature wraps JavaScript libraries with typed options, CSS/JS references, and automatic dependency ordering</p>
					<p waBody="s" waColorText="quiet" waText>Content Security Policy builder for CSP headers</p>
					<p waBody="s" waColorText="quiet" waText>11-layer deep CRTP component hierarchy: ComponentBase through ComponentEventBase</p>
					<p waBody="s" waColorText="quiet" waText>SPI-driven extension via ServiceLoader</p>
				</div>
				<wa-divider></wa-divider>
				<div class="wa-stack wa-gap-m">
					<div waCaption="s" waFontWeight="semibold" waText>EXAMPLES</div>
					<div class="wa-stack wa-gap-xs">
						<h4 waHeading="s" waText>Create a Page with Components</h4>
						<p waBody="s" waColorText="quiet" waText>Build a full HTML page with nested div, heading, and paragraph.</p>
						<markdown [data]="mdContent_85" class="aside-snippet-code wa-body-s" clipboard lineNumbers></markdown>
					</div>
					<div class="wa-stack wa-gap-xs">
						<h4 waHeading="s" waText>Server-Driven Click Event</h4>
						<p waBody="s" waColorText="quiet" waText>Attach a server-side click handler that runs Java code when the button is clicked.</p>
						<markdown [data]="mdContent_86" class="aside-snippet-code wa-body-s" clipboard lineNumbers></markdown>
					</div>
				</div>
				<div class="wa-stack wa-gap-xs">
					<div waCaption="s" waFontWeight="semibold" waText>QUICK START</div>
					<markdown [data]="mdContent_87" class="aside-snippet-code wa-body-s" clipboard lineNumbers></markdown>
				</div>
				<wa-divider></wa-divider>
				<div class="wa-stack wa-gap-s">
					<div waCaption="s" waFontWeight="semibold" waText>SPI EXTENSION POINT DETAILS</div>
					<div class="wa-stack wa-gap-xs">
						<div class="wa-cluster wa-gap-xs">
							<wa-tag pill variant="brand">IPageConfigurator</wa-tag>
							<wa-tag pill variant="neutral">uses</wa-tag>
						</div>
						<p waBody="s" waColorText="quiet" waText>Discovered at startup to inject CSS/JS references and configure the page before rendering</p>
					</div>
					<div class="wa-stack wa-gap-xs">
						<div class="wa-cluster wa-gap-xs">
							<wa-tag pill variant="brand">IPage</wa-tag>
							<wa-tag pill variant="neutral">uses</wa-tag>
						</div>
						<p waBody="s" waColorText="quiet" waText>Page implementations discovered via ServiceLoader for automatic route registration</p>
					</div>
					<div class="wa-stack wa-gap-xs">
						<div class="wa-cluster wa-gap-xs">
							<wa-tag pill variant="success">IGuiceModule</wa-tag>
							<wa-tag pill variant="neutral">provides</wa-tag>
						</div>
						<p waBody="s" waColorText="quiet" waText>Registers core Guice bindings for component model, event system, and rendering pipeline</p>
					</div>
					<div class="wa-stack wa-gap-xs">
						<div class="wa-cluster wa-gap-xs">
							<wa-tag pill variant="success">IOnComponentConfigured</wa-tag>
							<wa-tag pill variant="neutral">provides</wa-tag>
						</div>
						<p waBody="s" waColorText="quiet" waText>Callback fired after each component is configured, enabling post-processing hooks</p>
					</div>
					<div class="wa-stack wa-gap-xs">
						<div class="wa-cluster wa-gap-xs">
							<wa-tag pill variant="brand">ScriptProvider</wa-tag>
							<wa-tag pill variant="neutral">uses</wa-tag>
						</div>
						<p waBody="s" waColorText="quiet" waText>Provides dynamic JavaScript fragments injected into the page at render time</p>
					</div>
				</div>
				<div class="wa-stack wa-gap-xs">
					<div waCaption="s" waFontWeight="semibold" waText>SPI EXTENSION POINTS</div>
					<div class="wa-cluster wa-gap-xs">
						<wa-tag pill variant="success">provides IGuiceScanModuleInclusions</wa-tag>
						<wa-tag pill variant="success">provides IGuiceModule</wa-tag>
						<wa-tag pill variant="success">provides IGuicePreStartup</wa-tag>
						<wa-tag pill variant="success">provides IGuicePostStartup</wa-tag>
						<wa-tag pill variant="success">provides IOnComponentConfigured</wa-tag>
					</div>
					<div class="wa-cluster wa-gap-xs">
						<wa-tag pill variant="brand">uses IPageConfigurator</wa-tag>
						<wa-tag pill variant="brand">uses IPage</wa-tag>
						<wa-tag pill variant="brand">uses IOnClickService</wa-tag>
						<wa-tag pill variant="brand">uses IOnChangeService</wa-tag>
						<wa-tag pill variant="brand">uses IOnSubmitService</wa-tag>
						<wa-tag pill variant="brand">uses ScriptProvider</wa-tag>
					</div>
				</div>
				<wa-divider></wa-divider>
				<div class="wa-stack wa-gap-s">
					<div waCaption="s" waFontWeight="semibold" waText>CONFIGURATION</div>
					<div class="wa-stack wa-gap-xs">
						<div class="wa-cluster wa-gap-xs">
							<h4 waHeading="s" waText>Page.setTiny&#40;boolean&#41;</h4>
							<wa-tag pill variant="neutral">boolean</wa-tag>
						</div>
						<p waBody="s" waColorText="quiet" waText>Enable minified HTML output &mdash; removes whitespace and comments</p>
						<div waCaption="s" waColorText="quiet" waFontWeight="semibold" waText>Default: false</div>
					</div>
					<div class="wa-stack wa-gap-xs">
						<div class="wa-cluster wa-gap-xs">
							<h4 waHeading="s" waText>Page.setRunningLocalhost&#40;boolean&#41;</h4>
							<wa-tag pill variant="neutral">boolean</wa-tag>
						</div>
						<p waBody="s" waColorText="quiet" waText>Controls whether to serve from localhost or remote address</p>
						<div waCaption="s" waColorText="quiet" waFontWeight="semibold" waText>Default: true</div>
					</div>
				</div>
				<div class="wa-stack wa-gap-xs">
					<div waCaption="s" waFontWeight="semibold" waText>PREREQUISITES</div>
					<div class="wa-cluster wa-gap-xs">
						<wa-tag pill variant="neutral">Java 25 LTS</wa-tag>
						<wa-tag pill variant="neutral">Maven 3.9+</wa-tag>
					</div>
				</div>
				<wa-divider></wa-divider>
				<div class="wa-cluster wa-gap-s">
					<wa-tag pill variant="neutral">Upstream: https://jwebmp.com/</wa-tag>
					<wa-tag pill variant="neutral">Source: https://github.com/JWebMP/Core</wa-tag>
				</div>
			</div>
		</wa-card>
	</div>
</div>